import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SDropdownV3 } from "../../SDropdownV3";
export const VariableBooleanEditor = ({ value, onChangeValue, readOnly, onClickValue, placeholderValue })=>{
    const hasValue = (value === null || value === void 0 ? void 0 : value.value) !== undefined && (value === null || value === void 0 ? void 0 : value.value) !== null;
    const hasPlaceholder = (placeholderValue === null || placeholderValue === void 0 ? void 0 : placeholderValue.value) !== undefined && (placeholderValue === null || placeholderValue === void 0 ? void 0 : placeholderValue.value) !== null;
    const val = hasValue ? (value === null || value === void 0 ? void 0 : value.value) || false : (placeholderValue === null || placeholderValue === void 0 ? void 0 : placeholderValue.value) || false;
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        className: onClickValue ? "cursor-pointer" : "",
        children: /*#__PURE__*/ _jsx("div", {
            className: `${readOnly ? "pointer-events-none" : ""}`,
            children: hasValue ? /*#__PURE__*/ _jsxs("div", {
                onClick: ()=>{
                    onChangeValue && onChangeValue({
                        type: "variable-boolean",
                        value: hasValue ? !(value === null || value === void 0 ? void 0 : value.value) : !(placeholderValue === null || placeholderValue === void 0 ? void 0 : placeholderValue.value)
                    });
                },
                className: `cursor-pointer flex flex-row items-center justify-between rounded-md border border-white/10 bg-grayscale-dark h-[32px] px-[6px] pl-3`,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: `text-[13px] ${!hasValue && hasPlaceholder ? "opacity-50" : ""}`,
                        children: val ? "True" : "False"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: `relative w-[32px] h-[18px] transition rounded-full ${val ? "bg-brand-primary/10" : "bg-grayscale-lighter/50"} border border-white/10`,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: `w-[18px] h-[18px] top-[-1px] left-[-1px] absolute rounded-full border border-white/10 transform transition ${val ? "translate-x-[14px] bg-brand-primary" : "bg-white"}`
                        })
                    })
                ]
            }) : /*#__PURE__*/ _jsx(SDropdownV3, {
                borderless: false,
                className: "!h-[32px]",
                options: [
                    {
                        label: "True",
                        value: "true"
                    },
                    {
                        label: "False",
                        value: "false"
                    }
                ],
                onChange: (option)=>{
                    onChangeValue && onChangeValue({
                        type: "variable-boolean",
                        value: option.value === "true"
                    });
                }
            })
        })
    });
};
